export const environment = {
    SSO_OAUTH2_LOGOUT_ENDPOINT: 'https://sso.hom.capes.gov.br/sso/slo?RelayState=https://sicapes-individual-hom.apps-dht.capesocp.capes.gov.br/',
    SSO_OAUTH2_AUTHORIZE_ENDPOINT: 'https://sso.hom.capes.gov.br/sso/oauth',
    SSO_OAUTH2_REDIRECT_URI: 'https://sicapes-individual-hom.apps-dht.capesocp.capes.gov.br/auth',
    SSO_OAUTH2_REALM: '2',
    SSO_OAUTH2_CLIENT_ID: 'individual.capes.gov.br',
    SSO_OAUTH2_SCOPE: '',
    SSO_OAUTH2_STATE: 'capes_oauth',
    LOG_LEVEL: null,
    URL_API_CSAB: 'https://csab-bolsistas-servicos-hom.apps-dht.capesocp.capes.gov.br/',
    URL_API_BERTHA: 'https://plataforma-bertha-lutz-hom.apps-dht.capesocp.capes.gov.br/',
    production: false,
    ambiente: 'homologação'
};
export const environmentHom = environment;